module.exports = __webpack_public_path__ + "static/media/add-on.a6eced30.png";